import { SelfIssuedReceiptReasonEnum } from "@finway-group/shared/lib/models/expense/selfIssuedReceiptReason.enum"
import { Form, Radio, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { ExpenseRules } from "~Components/forms/rules"
import { useExpenseFormContext } from "~Components/modals/expenseCreateForm.context"
import { useEmployees } from "~Shared/hooks/employee.hooks"

export const SelfIssuedReceiptReason = () => {
    const { t } = useTranslation()
    const [{ expense, updateExpense, expenseForm }, _setCtx] = useExpenseFormContext()
    const employees = useEmployees({ excludeDeleted: true })
    const expenseRules = ExpenseRules({ expense, employees, formInstance: expenseForm })
    const isSelfIssuedReceipt = Form.useWatch("isSelfIssuedReceipt", expenseForm) ?? false

    if (!isSelfIssuedReceipt) {
        return null
    }

    return (
        <div className="border-finway-blue-accent-dark border-1 bg-finway-blue-light rounded-lg p-2 mb-8">
            <Form.Item
                name="selfIssuedReceiptReason"
                className="m-8"
                label={t("input:request.self_issued_receipt.reason.label")}
                required
                rules={expenseRules.selfIssuedReceiptReason}
            >
                <Radio.Group
                    onChange={(event) => {
                        const reason = event.target.value
                        expenseForm.setFieldsValue({ selfIssuedReceiptReason: reason })
                        updateExpense({ selfIssuedReceiptReason: reason })
                    }}
                >
                    <Row>
                        <Radio value={SelfIssuedReceiptReasonEnum.LOST}>{t("input:request.self_issued_receipt.reason.values.lost")}</Radio>
                    </Row>
                    <Row>
                        <Radio value={SelfIssuedReceiptReasonEnum.NOT_RECEIVED}>{t("input:request.self_issued_receipt.reason.values.not_received")}</Radio>
                    </Row>
                </Radio.Group>
            </Form.Item>
            <p className="text-finway-blue mx-8 mb-8 mt-0">{t("info:self_issued_receipt_reason")}</p>
        </div>
    )
}
